import React, { FC, ReactNode } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Pagination, EffectFade, Autoplay } from 'swiper';
import 'swiper/swiper-bundle.css';

import { Image } from '../Image';
import { compressImg } from '../../util/imgLoader';
import { useScreenSize } from '../ScreenSize';

import styles from './BannerCard.module.scss';

SwiperCore.use([Pagination, EffectFade, Autoplay]);

interface BgSloganType {
  content: string;
  sign: string;
}

interface BgConfig {
  /* 背景图 */
  bgUrl: string;
  /* 移动端背景图 */
  moBgUrl?: string;
  /* 背景的宣传标语 */
  slogan: BgSloganType;
}

interface Props {
  /* 背景设置 */
  bgConfigs: BgConfig[];

  /* 指导单位 */
  guidance: string;

  /**
   * banner 标题
   */
  title?: string;

  /**
   * 带有排序的标题
   */
  orderTitle?: string[];

  /**
   * 描述内容
   */
  description?: string | string[];

  /**
   * 移动端描述内容
   */
  moDescription?: string | string[];

  /**
   * 额外的信息
   */
  extra?: ReactNode;
}

const BannerCard: FC<Props> = (props) => {
  const { bgConfigs, title, orderTitle, moDescription, description, guidance, extra } = props;
  const speechBgimg = 'https://p0.meituan.net/smartvenus/cf86045e3f5ac4b5085caa2eb39f0f211340.png';

  const { size } = useScreenSize(); // 页面尺寸属性

  const cgccIcon = 'https://p0.meituan.net/smartvenus/db2e562c03f736c8d316bd14e95c0e775121.png';

  const desc = size.width < 1024 ? moDescription || description : description;

  const descNode = Array.isArray(desc) ? desc.map((descItem, idx) => <div key={idx}>{descItem}</div>) : desc;

  const orderTitleNode = Array.isArray(orderTitle)
    ? orderTitle.map((orderTitleItem, idx) => (
        <div className={styles['banner-card-content-order-title-item']} key={idx}>
          <div className={styles['banner-card-content-order-title-item-image']}>
            <Image objectFit="cover" src="//s3plus.meituan.net/fe-assets/images/csr-success-circle.png" layout="fill" />
          </div>
          <div className={styles['banner-card-content-order-title-item-content']}>{orderTitleItem}</div>
        </div>
      ))
    : null;

  return (
    <div className={styles['banner-card-container']}>
      <Swiper
        loop
        autoplay={{ delay: 3000 }}
        effect="fade"
        pagination={{
          el: `.${styles['swiper-pagination-container']}`,
          clickable: true,
          renderBullet: (_, className) => `<span class="${className}"></span>`,
          bulletClass: styles['swiper-pagination-bullet'],
          bulletActiveClass: styles['swiper-pagination-bullet-active'],
        }}
      >
        {bgConfigs.map(({ bgUrl, moBgUrl, slogan }, idx) => (
          <SwiperSlide key={idx}>
            <div className={styles['banner-card-image-container']}>
              {/* 移动端 */}
              <div className="block lg:hidden">
                <div className={styles['banner-card-image-content']}>
                  <Image layout="fill" objectFit="cover" src={compressImg({ imageUrl: moBgUrl || bgUrl })} />
                </div>
              </div>
              {/* PC端 */}
              <div className="hidden lg:block">
                <div className={styles['banner-card-image-content']}>
                  <Image layout="fill" objectFit="cover" src={compressImg({ imageUrl: bgUrl })} />
                </div>
              </div>
              {slogan && (
                <div className={styles['banner-card-imgae-slogan']}>
                  <div className={styles['banner-card-img-box']}>
                    <Image layout="fill" objectFit="cover" src={speechBgimg} />
                  </div>
                  <div className={styles['banner-card-image-slogan-content']}>{slogan.content}</div>
                  <div className={styles['banner-card-image-slogan-sign']}>{slogan.sign}</div>
                </div>
              )}
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      <div className={styles['banner-card-content-wrap']}>
        <div className={styles['swiper-pagination-container']} />
        <div className={styles['banner-card-content-container']}>
          {title && <div className={styles['banner-card-content-title']}>{title}</div>}
          {orderTitle && <div className={styles['banner-card-content-order-title']}>{orderTitleNode}</div>}
          {description && <div className={styles['banner-card-content-desc']}>{descNode}</div>}
          {guidance && (
            <div className={styles['banner-card-guidance']}>
              {guidance}
              <div className={styles['banner-card-guidance-icon']}>
                <Image src={cgccIcon} layout="fill" />
              </div>
            </div>
          )}
          {extra && <div className={styles['banner-card-extra']}>{extra}</div>}
        </div>
      </div>
    </div>
  );
};

export default BannerCard;
